module.exports = __webpack_public_path__ + "static/media/GER_cover.6764a8b7.gif";